<template>
  <div class="indoor">
    <div class="row">
      <div class="col-md-12">
        <div class="pagina-customizada" v-html="html"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { get, post } from "../helpers/api";
import AlbumInterno from "../components/interno/AlbumInterno";
import Loading from "../components/common/Loading.vue";

export default {
  name: "Door",
  components: {
    AlbumInterno,
    Loading
  },
  data() {
    return {
      title: "",
      content: "",
      html: "",
      externalItems: "",
      showContent: true
    };
  },
  mounted() {

    $( "body" ).children().css('height','100%');
    $( "html" ).children().css('overflow','hidden');
    $( "body" ).children().css('overflow','hidden');
    $('.player-top').remove();
    $('.player-bottom').remove();
    $('.rodape').remove();
    $('.navbar-header').remove();
    $('#navbar').remove();
    $('.navbar').remove();
    $('.banner').remove();
    $('#myCarousel').remove();

    $('.container').css('width', '100%');
    $('.container').css('height', '100%');
    $('.container').css('padding', '0');
    $('.container').css('margin', '0');
    $('.container div+div').css('height', '100%');
    $('.container').css('margin', '0');
    $('.container .indoor .row').css('display', 'block !important');

    $('.carousel').css('margin', '0');

    $('.col-md-12').css('margin', '0');
    $('.col-md-12').css('padding', '0');

    $('.row').css('margin', '0');
    $('.row').css('padding', '0');
    
    $('br').css('display', 'none');
    $('p').css('display', 'none !important');

    setTimeout(() => {
      $('.carousel').carousel({ interval: 5000, cycle: true });
    }, 2000);
    let self = this;

    get("pagina-door/" + this.$route.params.page).then(function(response) {
      self.title = response.data.result.data.name;
      self.html = response.data.result.data.html;
      self.externalItems = response.data.result.data.externalItems;
      self.showContent = false;
    });
  }
};
</script>

<style>
  .indoor, 
  .indoor .row, 
  .indoor .col-md-12, 
  .indoor .pagina-customizada, 
  .indoor .external-album, 
  .indoor .carousel, 
  .indoor .carousel-inner, 
  .indoor .carousel-inner .item{
    height: 100%;
  }
  .indoor .carousel-inner .item img{
    height: 100%;
    width: auto !important;
    margin: 0 auto;
  }
  .indoor .pagina-customizada p{
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/Door.vue